var HeroExpeditEvent = {};

HeroExpeditEvent.EmployEvent = "HeroExpeditEvent.EmployEvent" //伙伴信息

HeroExpeditEvent.EmploySendEvent = "HeroExpeditEvent.EmploySendEvent" //派出伙伴信息

HeroExpeditEvent.levelMessageEvent = "HeroExpeditEvent.levelMessageEvent" //关卡

HeroExpeditEvent.EmploySendEvent_Success = "HeroExpeditEvent.EmploySendEvent_Success" //派出伙伴成功

HeroExpeditEvent.HeroExpeditViewEvent = "HeroExpeditEvent.HeroExpeditViewEvent" //远征界面信息

HeroExpeditEvent.Get_Box_Event = "HeroExpeditEvent.Get_Box_Event" //领取宝箱


HeroExpeditEvent.Red_Point_Event = "HeroExpeditEvent.Red_Point_Event" //红点专用

module.exports = HeroExpeditEvent;